<script>
    import { createProvider } from '@/api/providers.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_PAG_PROVIDER_ADD}
        },
        methods: {
            async save() {
                const response = await createProvider(
                    this.$store.getters.PAG_PROVIDER_ADD
                );
                if (response != null) {
                    this.$store.commit('PROVIDER_PUSH', response);
                    response['game_name'] = [];
                    this.$store.commit('PAG_PROVIDER_PUSH', response);
                    this.$store.commit('IS_SHOW_PAG_PROVIDER_ADD', false);
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_PAG_PROVIDER_ADD', false)
            },
        }
    }
</script>


<template>
    <div>
        <button
            :disabled="isSave === false"
            class="button_blue_100"
            @click="save"
        >Create</button>
        <button
            class="button_blue_100 close_button mr_10"
            @click="close"
        >Close</button>
    </div>
</template>